module.exports = __webpack_public_path__ + "static/media/external-machine-03.216d48d0.png";